// Days and times as Estonia writes them, read back into the values the API
// takes. The browser's own date, time and month fields are drawn in the
// browser's language, so an English browser showed mm/dd/yyyy and 10:00 AM;
// the fields in this folder are plain text instead and come through here.
import dayjs from 'dayjs'

export const showDate = value => (value ? dayjs(value).format('DD.MM.YYYY') : '')
export const showDateTime = value => (value ? dayjs(value).format('DD.MM.YYYY HH:mm') : '')

// 8.10.2026, 08/10/2026, 8-10-26 → '2026-10-08'; anything else → null. A day
// that does not exist (31.02) is no day: dayjs would roll it into March.
// Digits alone too — 081026, 08102026: an iPhone's number pad, which the date
// fields ask for, has no dot, slash or dash on it.
export function parseDate (text) {
  const t = String(text || '').trim()
  const m = t.match(/^(\d{1,2})[./-](\d{1,2})[./-](\d{2}|\d{4})$/) || t.match(/^(\d{2})(\d{2})(\d{2}|\d{4})$/)
  if (!m) return null
  const year = m[3].length === 2 ? 2000 + Number(m[3]) : Number(m[3])
  const iso = year + '-' + m[2].padStart(2, '0') + '-' + m[1].padStart(2, '0')
  return dayjs(iso).format('YYYY-MM-DD') === iso ? iso : null
}

// 9, 930, 0930, 9:30, 9.30 → '09:30'; anything else → null.
export function parseTime (text) {
  const t = String(text || '').trim()
  let m = t.match(/^(\d{1,2})(?:[:.](\d{2}))?$/) || t.match(/^(\d{1,2})(\d{2})$/)
  if (!m) return null
  const h = Number(m[1])
  const min = Number(m[2] || 0)
  if (h > 23 || min > 59) return null
  return String(h).padStart(2, '0') + ':' + String(min).padStart(2, '0')
}

// '8.10.2026 9:30' → '2026-10-08T09:30'. A day alone keeps the time it had.
export function parseDateTime (text, previous) {
  const [day, time] = String(text || '').trim().split(/\s+/)
  const date = parseDate(day)
  if (!date) return null
  const hhmm = time ? parseTime(time) : (previous ? dayjs(previous).format('HH:mm') : '00:00')
  return hhmm ? date + 'T' + hhmm : null
}
